import Field from './Field';
import Picker from '../google/Picker';
import { loadPanel } from 'larasnap';
import { Message } from 'larasnap/support';

export default class extends Field {
    constructor(element, parent, props) {
        super(element, parent, {
            pickerEnabled: true,
            pickerRootFolderEnabled: false,
            pickerFolders: [],
            ...props,
        });

        this.find('button.enter-link').click(
            this.showEnterLinkField.bind(this),
        );
        this.find('button.google-drive').click(this.openDrivePicker.bind(this));
        this.find('.remove-file').click(this.remove.bind(this));
        this.find('button.enter-link-save').click(
            this.enterLinkSave.bind(this),
        );
        this.find('button.enter-link-cancel').click(
            this.enterLinkCancel.bind(this),
        );

        this.find('.edit-mode-enter-link input').keypress(
            this.onEnterLinkKeyPress.bind(this),
        );

        this.refresh();
    }

    refresh() {
        if (this.hasFolder()) {
            this.find('.edit-mode').hide();
            this.find('.view-mode').show();

            if (this.isEdit()) {
                this.find('.current-file-info').html(this.getFileInfoHtml());
            } else if (this.isView()) {
                this._view.html(this.getFileInfoHtml());
            }
        } else {
            this.find('.edit-mode').show();
            this.find('.view-mode').hide();
        }
    }

    setEnterLinkVisibility(isVisible) {
        this.find('.edit-mode-choose-option').toggle(!isVisible);
        this.find('.edit-mode-enter-link').toggle(isVisible);
    }

    showEnterLinkField() {
        this.setEnterLinkVisibility(true);
    }

    parseIdFromLink(link) {
        if (!link.includes('drive.google.com')) {
            return false;
        }
        link = link.split('?')[0];
        const parts = link.split('/');
        return parts[parts.length - 1];
    }

    onEnterLinkKeyPress(event) {
        if (event.keyCode === 13) {
            this.enterLinkSave();
            event.preventDefault();
        }
    }

    enterLinkSave() {
        const id = this.parseIdFromLink(
            this.find('.edit-mode-enter-link input').val(),
        );

        if (!id) {
            const example = 'https://drive.google.com/drive/folders/xxxxx...';
            Message.error({
                title: 'Invalid Google Drive folder link',
                message: `The link should look something like this:<br><br>${example}`,
            });
            return;
        }

        this.find('.edit-mode-enter-link input').val('');

        this.setEnterLinkVisibility(false);
        this.setValue(id);
        this.refresh();
    }

    enterLinkCancel() {
        this.setEnterLinkVisibility(false);
    }

    openDrivePicker() {
        new Picker({
            folders: this._props.pickerFolders,
            root_folder_enabled: this._props.pickerRootFolderEnabled,
            on_select: this.onDriveFileSelected.bind(this),
            folders_only: true,
        }).show();
    }

    onDriveFileSelected(file) {
        this.setValue(file.id);
        this.refresh();
    }

    selectMobileUpload() {
        const panel = loadPanel('uploadManager');
        panel.setFileField(this);
    }

    getFileInfoHtml() {
        if (!this.hasFolder()) {
            return '';
        }

        const id = this.getValue();
        const url = `https://drive.google.com/drive/folders/${id}`;

        return `
            <div  class="d-flex justify-content-center align-items-center">
                <i class="fa-brands fa-google-drive" style="font-size: 1.2rem"></i>
                <a target="_blank" href="${url}" class="pl-1">View Folder</a>
            </div>
        `;
    }

    hasFolder() {
        return !!this.getValue();
    }

    remove() {
        this.setValue('');
        this.refresh();
    }

    setValue(id) {
        this._input.val(id);
        this.refresh();
        return this;
    }
}
